import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { logger } from 'utils/logger';
import { bulkDisallowBroadcast } from 'features/permissions/actions';

export function* bulkDisallowBroadcastSaga(action: ReturnType<typeof bulkDisallowBroadcast>) {
  const { roles } = action.payload;

  logger
    .remote({ action: true, tier: 1 })
    .info(`The user bulk disallowed broadcast for roles=${roles.join(',')}`);

  yield call(SignalingSocket.send, {
    event: 'bulkDisallowBroadcast',
    data: { roles },
  });
}
